module.exports = __webpack_public_path__ + "img/unidad_de_mantenimiento.29ca5958.jpg";